// extracted by mini-css-extract-plugin
export default {"requested_stage":"DataTableSupervisor_requested_stage__aTYhn"};